import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { SelectTree } from '@tencent/spaui';
import { withApi } from '@tencent/react-aio';
import * as ActionTypes from '@/stores/sale/actions';

interface CleanReasonConfig {
  reasonFilterList: Record<string, object[]>;
  isOpenStateTag: boolean;
}

interface LeadReasonSelectProps {
  props: {
    multiple: boolean;
    unrelated: boolean;
  };
  value: number | number[];
  onChange: () => void;
  onClear: () => void;
  cleanReasonConfig: CleanReasonConfig; // 原因标签data
  cleaningStatus: string[]; // 线索状态
  webApi: {
    searchLeadReasonTag: () => any;
  };
}

class LeadReasonSelect extends React.PureComponent<LeadReasonSelectProps> {
  constructor(props: LeadReasonSelectProps) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const { webApi, cleanReasonConfig: { reasonFilterList } } = this.props
    if (!reasonFilterList) {
      webApi
        .searchLeadReasonTag()
        .dispatchJson(ActionTypes.FETCH_CLEAN_REASON_CONFIG)
    }
  }

  handleData = () => {
    const { cleanReasonConfig: { reasonFilterList }, cleaningStatus, } = this.props
    let data: any[] = []
    if (!reasonFilterList) return data
    if (cleaningStatus?.length > 0) {
        _.map(cleaningStatus, v => {
        if (reasonFilterList[v]) {
          data = [...data, ...reasonFilterList[v]]
        }
      })
    } else {
      data = [..._.flatten(_.values(reasonFilterList))]
    }
    data.forEach((item) => {
      item['data-report'] = `lead-reason-select-${item.value}`;
    });
    return data
  }

  render() {
    const { props, value, onClear, onChange } = this.props
    const data = this.handleData()
    return (
      <SelectTree
        data-report='lead-reason-select'
        {...props}
        className="SourceTypeTagSelect"
        data={data}
        value={value}
        search={false}
        clearable={true}
        onChange={onChange}
        onClear={onClear}
      />
    )
  }
}
function mapStateToProps(state: {
  cleanReasonConfig: CleanReasonConfig;
  }) {
  return {
    cleanReasonConfig: state.cleanReasonConfig,
  }
}

export default withApi(connect(mapStateToProps, {})(LeadReasonSelect))
